import clsx from "clsx";
import { useState } from "react";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { LoadingSpinner } from "shared-components";

interface Props {
  technicalData: string[];
  className?: string;
  loading?: boolean;
}

export const ProductTechnicalData = ({ technicalData, className, loading }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={clsx("w-full", className)}>
      <button
        className={
          "flex w-full items-center justify-between rounded-lg bg-base-white p-2 " +
          "outline outline-2 outline-base-input *:text-brand-accent"
        }
        onClick={handleToggleExpand}
        disabled={loading}
      >
        <b className="!text-brand-primary">Ficha técnica</b>
        {loading ? <LoadingSpinner /> : isExpanded ? <MdExpandLess size="1.5rem" /> : <MdExpandMore size="1.5rem" />}
      </button>
      {isExpanded && (
        <div className={"z-10 mt-2 w-full rounded-lg border-2 border-base-input bg-base-white p-2"}>
          <div className="!bg-base-white p-2">
            {technicalData.map((data, index) => (
              <p key={index}>{data}</p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
